import { TDocument } from 'shared/model/doc-base';
import { findDocs } from 'shared/utils/pouchDB/general';
import { DocType, DocTypeFiles, TDocFile } from 'shared/constants/docs';

export async function getProjectTotals(projectIds: string[], db: PouchDB.Database<TDocument>) {
	const files = (await findDocs(
		{
			options: {
				selector: {
					$and: [
						{ type: { $in: [DocType.FILE_FINISH_AUDIO, DocType.FILE_FINISH_VIDEO] } },
						{ projectId: { $in: projectIds } },
					],
				},
			},
			fields: ['_id', 'type', 'projectId'],
		},
		db,
	)) as TDocFile[];

	const result = Object.fromEntries(
		projectIds.map((projectId) => [
			projectId,
			{ [DocType.FILE_FINISH_AUDIO]: 0, [DocType.FILE_FINISH_VIDEO]: 0 },
		]),
	);

	files.forEach(({ type, projectId }) => {
		result[projectId][type as DocType.FILE_FINISH_AUDIO | DocType.FILE_FINISH_VIDEO] += 1;
	});

	return result;
}

export const getProjectFileCount = (
	item: { _totals: { fileCount: Partial<Record<DocTypeFiles, number>> }},
	fileType: DocTypeFiles
) => (
	(item && item._totals && !!item._totals.fileCount)
		? item._totals.fileCount[fileType] ?? null
		: null
);
